import { Modal } from '@mui/material';
import { Button, IconButton } from 'app/agriculture/components/Button/Button';
import { getTimestampDateFormat } from 'app/agriculture/components/Timestamp/timestampUtils';
import { CollapseIcon, DownloadIcon } from 'app/agriculture/icons';
import classNames from 'classnames';
import { format as formatDate } from 'date-fns';

import './ImageModal.scss';
import { Link } from 'react-router-dom';

interface ImageModalProps {
    src: string;
    alt?: string;
    timestamp?: Date;
    className?: string;
    heading: string;
    open: boolean;
    onClose: () => void;
}

export function ImageModal({
    heading,
    src,
    alt = '',
    timestamp,
    className,
    open,
    onClose,
}: ImageModalProps) {
    // This is required so that the download works
    const imagePath = `${window.origin}/${src}`;

    return (
        <Modal className={classNames('ImageModal', className)} open={open} onClose={onClose}>
            <div className="ImageModal__inner" data-testid="ImageModal">
                <div className="ImageModal__header">
                    <h5 className="ImageModal__heading">{heading}</h5>
                    <Link
                        className="ImageModal__download"
                        to={imagePath}
                        download={imagePath}
                        target="_blank"
                    >
                        <Button
                            variant="textonly"
                            text="Download Photo"
                            startIcon={<DownloadIcon />}
                        />
                    </Link>
                </div>
                <div className="ImageModal__content">
                    <IconButton
                        id="ImageModalClose"
                        className="ImageModal__button"
                        icon={<CollapseIcon size={16} />}
                        tooltip="Collapse image"
                        onClick={onClose}
                        variant="textonly"
                    />
                    <img className="ImageModal__image" src={src} alt={alt} />
                    {!timestamp ? null : (
                        <div className="ImageModal__timestamp">
                            {formatDate(timestamp, getTimestampDateFormat(timestamp))}
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
}
